import {
    AggregationModel,
    AggregationResponse,
    ApiResultFailed,
    AuditShiftTypeModel,
    GrouppedQueryModel,
    HttpResponse,
    Operation,
    RequestParams,
} from '@/libs/Api';
import ApiService from '@/libs/core/api-service';
import { CrudDataQuery, CrudService } from '@/libs/core/+state/models/crud-service';
import { CrudEnumerableResponse, CrudResponse } from '../core/+state/models/crud-response';

export class AuditShiftTypesDataService implements CrudService<AuditShiftTypeModel, AuditShiftTypeModel> {
    getAll(query: CrudDataQuery<AuditShiftTypeModel>): Promise<CrudEnumerableResponse<AuditShiftTypeModel>> {
        return ApiService.api.getAuditShiftTypeBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<AuditShiftTypeModel>): Promise<CrudEnumerableResponse<AuditShiftTypeModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<AuditShiftTypeModel>> {
        return ApiService.api.getAuditShiftTypeById(id, params);
    }

    create(item: AuditShiftTypeModel, params?: RequestParams): Promise<CrudResponse<AuditShiftTypeModel>> {
        return ApiService.api.insertAuditShiftType(item, params);
    }

    update(item: AuditShiftTypeModel, params?: RequestParams): Promise<AuditShiftTypeModel> {
        return ApiService.api.updateAuditShiftType(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<AuditShiftTypeModel> {
        return ApiService.api.patchAuditShiftType(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<AuditShiftTypeModel>): Promise<CrudEnumerableResponse<AuditShiftTypeModel>> {
        return ApiService.api.deleteAuditShiftTypes(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationAuditShiftType(query, params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<AuditShiftTypeModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: AuditShiftTypeModel, params?: RequestParams): Promise<CrudResponse<AuditShiftTypeModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getAuditShiftTypeGroupped(query, params);
    }
}
